<template>
  <div v-if="muscle" class="dcf-form">
    <img v-if="muscle.image" :src="muscle.image" class="dcf-float-right dcf-ml-2 dcf-mb-2" />
    <h2>{{ muscle.name }}</h2>
      
      <dl>
        <template v-if="muscle.common_name">
          <dt>Common Name</dt>
          <dd>{{ muscle.common_name }}</dd>
        </template>

        <template v-if="muscle.group">
          <dt>Group</dt>
          <dd>{{ muscle.group }}</dd>
        </template>

        <template v-if="muscle.primal">
          <dt>Wholesale Section</dt>
          <dd>{{ muscle.primal }}</dd>
        </template>

        <template v-if="muscle.origin">
          <dt>Origin</dt>
          <dd>{{ muscle.origin }}</dd>
        </template>

        <template v-if="muscle.insertion">
          <dt>Insertion</dt>
          <dd>{{ muscle.insertion }}</dd>
        </template>

        <template v-if="muscle.action">
          <dt>Action</dt>
          <dd>{{ muscle.action }}</dd>
        </template>

        <template v-if="muscle.innervation">
          <dt>Innervation</dt>
          <dd>{{ muscle.innervation }}</dd>
        </template>

        <template v-if="muscle.blood_supply">
          <dt>Blood Supply</dt>
          <dd>{{ muscle.blood_supply }}</dd>
        </template>

        <template v-if="muscle.retail_cuts">
          <dt>Retail Cuts</dt>
          <dd>{{ muscle.retail_cuts }}</dd>
        </template>
      </dl>


      <div v-if="muscle.profile">
        <h3 class="dcf-txt-md">Profile:</h3>
        <dropdown v-model="selectedProfile" :options="profiles" class="dcf-mb-2">
          <template #option="slotProps">
            <div>
              Type: <span v-text="(slotProps.option.type == 'D') ? 'Dairy' : 'Beef'"></span><br />
              Weight: {{ slotProps.option.weight }}<br />
              Muscling: {{ slotProps.option.muscling }}<br />
              Fat Thickness: {{ slotProps.option.fat_thick }}<br />
              Maturity: {{ slotProps.option.maturity }}<br />
            </div>
          </template>
          <template #value="slotProps">
            <div v-if="slotProps.value">
              Type: <span v-text="(slotProps.value.type == 'D') ? 'Dairy' : 'Beef'"></span><br />
              Weight: {{ slotProps.value.weight }}<br />
              Muscling: {{ slotProps.value.muscling }}<br />
              Fat Thickness: {{ slotProps.value.fat_thick }}<br />
              Maturity: {{ slotProps.value.maturity }}<br />
            </div>
            <div v-else>
              &hellip;
            </div>
          </template>
        </dropdown>

        <table class="dcf-table">
        <thead>
          <tr>
            <th>Property</th>
            <th>Value</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="variable in vars">
            <th>
              {{ variable.label_name }}
            </th>
            <td class="dcf-txt-right" v-text="getProfileValue(variable.id, selectedProfile.id)">
            </td>
          </tr>
        </tbody>
      </table>
        
        <!-- table>
          <thead>
            <tr>
              <th rowspan="2">Profile</th>
              <th>Properties</th>
            </tr>
            <tr>
              <th v-for="variable in vars"> {{ variable.label_name }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="profile in profiles">
              <th>
                Type: <span v-text="(profile.type == 'D') ? 'Dairy' : 'Beef'"></span><br />
                Weight: {{ profile.weight }}<br />
                Muscling: {{ profile.muscling }}<br />
                Fat Thickness: {{ profile.fat_thick }}<br />
                Maturity: {{ profile.maturity }}<br />
              </th>
              <td v-for="variable in vars" v-text="getProfileValue(variable.id, profile.id)"></td>
            </tr>
          </tbody>
        </table -->

      </div>

  </div>
</template>

<script>

import Dropdown from 'primevue/dropdown';


export default {
  props: ['muscle', 'profiles'],
  components: { dropdown: Dropdown },
  data: function(){
    return {
        vars: [],
        selectedProfile: null
      }
  },
  methods: {
    getProfileValue: function(label_id, profile_id){
      return (this.muscle.profile && this.muscle.profile[ profile_id ] && this.muscle.profile[ profile_id ][ label_id ]) ? this.numberPrecision( this.muscle.profile[ profile_id ][ label_id ].mean, 3) : '---';
    },
    numberPrecision: function(val, precision){
      if(typeof val === 'string' || val instanceof String){
          return val;
        }

        val = parseFloat(val);

        if( val > 1000000){
          return val.toExponential();
        }
        if(isNaN(val)){
          return 'No Values';
        }
        return val.toLocaleString('en-US', {maximumFractionDigits: precision});

    }
  },
  created: function(){

      this.vars = window.variables;
      this.selectedProfile = this.profiles[0];
  }
}

</script>
